import React, { useState } from "react";
import { StorySubmission } from "../../../types";
import Waitable from "../../common/waitable/waitable";
import { GameStatus } from "../../../types/game-status";
import { useAppSelector } from "../../../redux/store";
import FormPage from "../../common/formpage/formpage";
import AvatarHeader from "../../common/avatar-header/avatar-header";
import { useGameFormData } from "../../../hooks/useGameFormData";
import { useGameForm } from "../../../hooks/useGameForm";
import PrevSubmission from "../../common/prev-submission/prev-submission";

const StoryCensor = () => {
  const formData = useGameFormData();

  const gameState = useAppSelector((state) => state.game);
  let flatMap: StorySubmission[] | undefined = gameState.game?.stories
    ?.flatMap((s) => s.submissions)
    .filter((s) => s.meta && s.meta.flagged && s.meta.flagged.length > 0);

  const [censored, setCensored] = useState(new Set<number>());

  function handleToggle(id: number, checked: boolean) {
    setCensored((prevState) => {
      const newSet = new Set(prevState);
      if (checked) {
        newSet.add(id);
      } else {
        newSet.delete(id);
      }
      return newSet;
    });
  }

  function gameSubmit() {
    return {
      body: {
        vip_action: {
          censor_submission: Array.from(censored),
        },
      },
      code: "submission/censor",
    };
  }

  const { handleSubmit, avatarHeaderProps } = useGameForm({
    gameSubmit,
    playerState: formData.playerState,
  });

  return (
    <Waitable
      playerActionHandler={() => { }}
      waitingFor={[GameStatus.GameStatusPostCensoring]}
      waitHeader={"Waiting for censoring"}
    >
      <FormPage
        header={
          <AvatarHeader titles={["Moderation screen"]} {...avatarHeaderProps} />
        }
        {...formData}
        subHeaders={[
          "Choose to censor or keep parts other players have flagged.",
          "Wait until other players have finished their titles.",
        ]}
        onSubmit={handleSubmit}
      >
        <div className="relative m-1 whitespace-pre-wrap normal-case text-lg max-w-full divide-y divide-gray-200">
          {flatMap && flatMap.length > 0
            ? flatMap?.map<React.ReactNode>((s) => (
              <PrevSubmission
                key={"flagsubm-" + s.id}
                variant="censor"
                onToggle={handleToggle}
                submission={s}
              />
            ))
            : ""}
        </div>
      </FormPage>
    </Waitable>
  );
};

export default StoryCensor;
